import { cn } from "@/lib/utils";

const IMG_FLAG = "/life-milestone/figma-flag-main.svg";
const IMG_MARKER = "/life-milestone/figma-marker-tick.svg";

/** Design canvas 32×28; mobile spec 20×18.23 (IIT KGP / Figma handoff) */
const CANVAS_W = 32;
const CANVAS_H = 28;
const MOBILE_W = 20;
const MOBILE_H = 18.23;

/**
 * Figma node 10485:2426 — exported assets + white connector (10485:2433).
 * No custom-drawn shapes; layout matches design positioning.
 */
export function MilestoneFlagIcon({
  className,
  size = "default",
}: {
  className?: string;
  size?: "default" | "mobile";
}) {
  const inner = (
    <>
      <div className="absolute left-[22.85px] top-[22.74px] flex h-[7.58px] w-[11.148px] items-center justify-center">
        <div className="-rotate-90">
          <div className="relative h-[11.148px] w-[7.58px]">
            <img
              alt=""
              src={IMG_MARKER}
              className="absolute inset-0 block size-full max-w-none"
            />
          </div>
        </div>
      </div>
      <div className="absolute left-0 top-0">
        <div className="absolute left-[6.69px] top-0 h-[23.661px] w-[18.393px]">
          <img
            alt=""
            src={IMG_FLAG}
            className="absolute inset-0 block size-full max-w-none"
          />
        </div>
        <div className="absolute left-0 top-[23.19px] h-[0.473px] w-[23.41px] bg-white" />
      </div>
    </>
  );

  if (size === "mobile") {
    return (
      <div
        className={cn(
          "relative inline-block shrink-0 overflow-visible",
          "h-[18.23px] w-[20px]",
          className,
        )}
        aria-hidden
      >
        <div
          className="origin-top-left"
          style={{
            width: CANVAS_W,
            height: CANVAS_H,
            transform: `scale(${MOBILE_W / CANVAS_W}, ${MOBILE_H / CANVAS_H})`,
            transformOrigin: "top left",
          }}
        >
          <div className="relative h-[28px] w-[32px] shrink-0 overflow-visible">{inner}</div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={cn(
        "relative inline-block h-[28px] w-[32px] shrink-0 overflow-visible",
        className,
      )}
      aria-hidden
    >
      {inner}
    </div>
  );
}
